import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import { useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import { useTheme } from "../../Hooks/ThemeContext/ThemeContext";

const JobTitlesTable = (props: { filter: any }) => {
  const themePage = useTheme();
  const [eventLogList, setEventLogList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    geteventLogList();
  }, [page, props.filter, totalItems]);

  const geteventLogList = async () => {
    try {
      const response = await axiosInstance.get(
        `/v1/event-log?type_dom_corp=${themePage.theme}&page=${page}&items_per_page=${limit}`,
        {
          params: props.filter,
        }
      );

      const data = response.data;
      setEventLogList(data.result.data);

      setTotalItems(data.result.data.length);

    } catch (err) {
      console.log(err);
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };


  return (
    <>
      <section>
        <TableContainer component={Paper}>
          <Table >
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>User Id</TableCell>
                <TableCell>Event Type</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Note</TableCell>
                <TableCell>Created At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eventLogList.map((data: any, key: number) => {
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{data.user_id}</TableCell>
                    <TableCell>{data.event_type}</TableCell>
                    <TableCell>{data.action}</TableCell>
                    <TableCell>{data.note}</TableCell>
                    <TableCell>{data.created_at}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={totalItems}
                rowsPerPage={limit}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              // ActionsComponent={TablePaginationActions}
              />
          </Table>
        </TableContainer>
        
      </section>
    </>
  );
};

export default JobTitlesTable;